module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-1-5.190d2d2f.png";